@if (appFacadeService.isDialogDisplayed() | async) {
<ng-container class="payment-success-dialog-container">
    @if ((appFacadeService.getDialogContentType() | async) === dialogContentType.PaymentSuccess) {
    <por-app-confirm-dialog (confirmed)="appFacadeService.toggleDialog(false)" [message]="dialogMessage">
        @if (appFacadeService.getLastPaymentTransactionData() | async; as transactionData) { @switch (transactionData?.TransactionResultEnum) { @case (transactionResultEnum.PENDING) {
        <p>
            <span class="title">{{ 'PaymentPending' | translate }}</span>
        </p>
        } @case (transactionResultEnum.DECLINED) {
        <p>
            <span class="title">{{ 'PaymentDeclined' | translate }}</span>
        </p>
        <hr />
        } @case (transactionResultEnum.CANCELLED) {
        <p>
            <span class="title">{{ 'PaymentCancelled' | translate }}</span>
        </p>
        <hr />
        } @case (transactionResultEnum.ERROR) {
        <p>
            <span class="title">{{ 'PaymentErrorHeading' | translate }}</span>
        </p>
        <hr />
        } @case (transactionResultEnum.APPROVEDWITHWARNING) {
        <p>
            <span class="title">{{ 'PaymentSuccessWithWarning' | translate }}</span>
        </p>
        } @case (transactionResultEnum.APPROVED) {
        <p>
            <span class="title">{{ (isTokenizeCard(transactionData) ? 'CardSaved' : 'PaymentReceived') | translate }}</span>
        </p>
        } } @if ((appFacadeService.isLastPaymentConfirmationPending() | async) === true && !isTokenizeCard(transactionData)) {
        <p class="pending-confirmation-msg" porAddFeature [featureName]="'paymentConfirmationPendingMsg'">{{ 'PaymentConfirmationPending' | translate }}</p>
        } @if ((appFacadeService.isPaymentApproved() | async) === true) { @if (isTokenizeCard(transactionData)) {
        <!-- Tokenize-only: no money moved, so no thank-you-for-your-payment and no amount. -->
        <p class="thanks-msg">{{ 'CardSavedThankYou' | translate }}</p>
        <hr />
        } @else {
        <p class="thanks-msg">{{ 'ThankYouForYourPayment' | translate }}</p>
        <hr />
        <p>
            <span>{{ 'PaymentAmount' | translate }}:</span>
            <span>
                &nbsp;
                {{ (transactionData?.Amount_Processed ?? 0) / 100 | formatCurrency : (appFacadeService.getPaymentCurrency() | async) }}
            </span>
        </p>
        } }
        <p>
            <span>{{ 'DateTime' | translate }}:</span>
            <span>&nbsp;{{ transactionData?.Created ?? '' | formatDate : appFacadeService.featureToggleService.isSyrinx() : dateFormat }}</span>
        </p>
        <p>
            <span>{{ 'PaymentType' | translate }}:</span>
            <span>&nbsp;{{ appMediatorService.porPayService.getPaymentMethod(transactionData?.PaymentMethodEnum) }}</span>
        </p>
        } @if (appFacadeService.getLastPaymentTransactionId() | async; as transactionId) {
        <p>
            <span>{{ 'Reference#' | translate }}:</span>
            <span>&nbsp;{{ transactionId }}</span>
        </p>
        } @if (appFacadeService.getLastPaymentTransactionStatus() | async; as status) {
        <p>
            <span>{{ 'Description' | translate }}:</span>
            <span>&nbsp;{{ status?.Description }}</span>
        </p>
        }
    </por-app-confirm-dialog>
    }
</ng-container>
}
